import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import SEOHead from '@/components/base/SEOHead';
import HeroSection from './components/HeroSection';
import PhilosophySection from './components/PhilosophySection';
import CategoriesSection from './components/CategoriesSection';
import FeaturedArticles from './components/FeaturedArticles';
import CTASection from './components/CTASection';

export default function Home() {
  const canonicalUrl = 'https://jiuqugan.com/';

  return (
    <>
      <SEOHead
        title="就去干——行动力觉醒 | 打破拖延，立即行动"
        description="就去干是一种彻底打破拖延、立即付诸行动的人生哲学。无论你面对多大的目标、多深的恐惧，就去干，才是改变命运的唯一起点。本平台帮你激活行动基因，从此告别空想。"
        keywords="就去干,就去干行动力,就去干打破拖延,立即行动方法论,行动力觉醒训练,告别拖延症,执行力提升"
        canonicalUrl={canonicalUrl}
        ogImage="https://readdy.ai/api/search-image?query=A%20powerful%20silhouette%20of%20a%20person%20running%20toward%20a%20glowing%20golden%20sunrise%20on%20a%20mountain%2C%20inspiring%20atmosphere%2C%20bold%20and%20energetic%2C%20cinematic%20wide%20format%2C%20warm%20orange%20and%20amber%20tones&width=1200&height=630&seq=jiuqugan-og-home&orientation=landscape"
      />

      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@graph': [
              {
                '@type': 'Organization',
                name: '就去干',
                url: canonicalUrl,
                description: '行动力觉醒平台，帮助人们打破拖延、立即行动',
                foundingDate: '2024',
              },
              {
                '@type': 'WebSite',
                name: '就去干',
                url: canonicalUrl,
                description: '打破拖延、立即行动的行动力觉醒平台',
                potentialAction: {
                  '@type': 'SearchAction',
                  target: `${canonicalUrl}search?q={search_term_string}`,
                  'query-input': 'required name=search_term_string',
                },
              },
              {
                '@type': 'WebPage',
                name: '就去干——行动力觉醒',
                url: canonicalUrl,
                description: '就去干是一种彻底打破拖延、立即付诸行动的人生哲学。',
                isPartOf: { '@type': 'WebSite', name: '就去干', url: canonicalUrl },
              },
            ],
          }),
        }}
      />

      <div className="min-h-screen bg-background-50">
        <Navbar />
        <main>
          <HeroSection />
          <PhilosophySection />
          <CategoriesSection />
          <FeaturedArticles />
          <CTASection />
        </main>
        <Footer />
      </div>
    </>
  );
}